<template>
  <span v-if="state" class="voucher-status" :class="`voucher-status--${state.tone}`" :title="detail">
    <!-- check -->
    <svg v-if="state.tone === 'ok'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
    <!-- alerta -->
    <svg v-else-if="state.tone === 'alert'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
    <!-- a revisar -->
    <svg v-else-if="state.tone === 'review'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    <!-- revisada a mano -->
    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
    </svg>
    {{ state.label }}
  </span>
</template>

<script>
/*
 * Veredicto de la verificación automática de un comprobante.
 *
 * El campo `voucherAudit` lo escribe una Cloud Function; aquí sólo se muestra.
 * Una letra sin comprobantes no renderiza nada: no hay nada que verificar.
 */

// Un motivo puede acumularse con otro (faltante + fecha). Manda el primero,
// que es el que el motor considera principal.
const ALERT_LABELS = {
  amount_short: 'No coincide',
  unreadable: 'Ilegible',
  date: 'Fecha',
  no_voucher: 'Sin comprobante'
}
const REVIEW_LABELS = {
  amount_over: 'Excedente',
  currency_review: 'Revisar moneda',
  weak_sum: 'Suma dudosa'
}

export default {
  name: 'VoucherStatus',
  props: {
    audit: { type: Object, default: null }
  },
  computed: {
    state () {
      // Sin veredicto no se muestra NADA. Antes decía "Sin verificar", y como el
      // histórico no se audita por diseño, ese gris salía en el 99.7% de las
      // letras con comprobante: la etiqueta ocupaba la columna entera sin
      // informar de nada y hacía dudar de las que sí dicen algo.
      if (!this.audit || !this.audit.status) return null
      // Cerrada a mano: gris silencioso. No dice que el monto cuadre, dice que
      // alguien la miró y la dio por buena.
      if (this.audit.resolved) return { tone: 'pending', label: 'Revisada' }

      const reason = (this.audit.reasons && this.audit.reasons[0]) || null
      if (this.audit.status === 'ok') return { tone: 'ok', label: 'Coincide' }
      if (this.audit.status === 'review') return { tone: 'review', label: REVIEW_LABELS[reason] || 'Revisar' }
      return { tone: 'alert', label: ALERT_LABELS[reason] || 'Revisar' }
    },
    detail () {
      return this.audit && this.audit.detail ? this.audit.detail : ''
    }
  }
}
</script>
